<template>
    <div class="container mt-5">

        <h6>Olá {{ $store.state.auth.user.name }}, </h6>
        <p>Estamos verificando o seu acesso, aguarde!</p>

        <div class="row">
            <div class="col-12">
                <div class="d-flex justify-content-center">
                    <div class="spinner-border" role="status" v-if="spinners">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import ApiService from '../../../common/api.service';
export default {
    name: "e_24h",
    created() {
        this.loadData();
    },

    data() {
        return {
            spinners: false,
            login24h: {
                data: []
            }

        }
    },
    methods: {
        returnManin() {
            window.location.href = '/conteudo-exclusivo';
        },
        async loadData() {
            this.spinners = true,
                this.personal_loadin = 0,
                await ApiService.post('v1/login-24h', {
                    emailUser: this.$store.state.auth.user.email,

                })
                    .then(response => {
                        this.login24h = response;

                    })
                    .catch(function (error) {
                        console.log(error);
                    })
                    .finally(() => {

                        if (!this.login24h.data.ret_24h.idErro) {
                            window.location.href = this.login24h.data.urlAprovada;
                        } else {

                            this.$swal({
                                type: 'error',
                                title: 'Oops... ' + this.login24h.data.urlAprovada,
                                text: 'Erro: ' + this.login24h.data.ret_24h.idErro + ' - ' + this.login24h.data.ret_24h.erro,

                                confirmButtonText: 'Retornar',
                                footer: '<a href="/contato" class="text-center">Havendo dúvidas entre em contato</a>',
                                padding: '2em'
                            }).then(result => {
                                if (result.value) {
                                    this.returnManin();
                                }
                            });

                        }
                        this.spinners = false
                    });
        },
    }
}
</script>